var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DetailControl',{attrs:{"title":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/detail/index.vue?vue&type=template&id=75c5268e&scoped=true
// module id = null
// module chunks = 